import { isSoldOut } from '@/lib/stock';
import { Link } from 'react-router-dom';
import { ShoppingBag } from 'lucide-react';
import kgPedestal from '@/assets/home-v2/kg-pedestal.webp.asset.json';
import { useProductsByHandle, useAddToCart, useViewItemList, priceInfo, PriceBlock, Reveal, Eyebrow, H2 } from './shared';
import { PurchaseBenefits } from './PurchaseBenefits';

const H_1KG = 'hidratante-corporal-dermoconstrutor-1kg';
const H_80G = 'hidratante-corporal-dermoconstrutor-80g';

const perGram = (value: number, grams: number) =>
  (value / grams).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

export const FamilySize = () => {
  const { map } = useProductsByHandle();
  const addToCart = useAddToCart();
  const big = map.get(H_1KG);
  const small = map.get(H_80G);
  useViewItemList('Tamanho família', [big]);

  const bigInfo = priceInfo(big);
  const smallInfo = priceInfo(small);

  return (
    <Reveal as="section" className="bg-v2-bg text-v2-ink py-16 md:py-24">
      <div className="container mx-auto px-4 max-w-6xl">
        <div className="rounded-3xl bg-v2-blue/15 overflow-hidden grid md:grid-cols-2">
          <div className="aspect-[4/3] md:aspect-auto">
            <img src={kgPedestal.url} alt="Hidratante Corporal NAT HOF de 1kg sobre pedestal" width={1200} height={900} loading="lazy" decoding="async" className="w-full h-full object-cover" />
          </div>
          <div className="p-6 md:p-10 min-w-0">
            <Eyebrow>Tamanho família · 1kg</Eyebrow>
            <H2>O mesmo creme. Para a casa toda.</H2>
            <dl className="mt-6 grid grid-cols-3 gap-3">
              <div>
                <dt className="font-narrow text-2xl md:text-3xl font-semibold">12×</dt>
                <dd className="text-sm text-v2-muted">o conteúdo do 80g</dd>
              </div>
              <div>
                <dt className="font-narrow text-2xl md:text-3xl font-semibold">
                  {bigInfo ? `R$ ${perGram(bigInfo.current, 1000)}` : '—'}
                </dt>
                <dd className="text-sm text-v2-muted">
                  por grama{smallInfo ? ` (R$ ${perGram(smallInfo.current, 80)} no 80g)` : ''}
                </dd>
              </div>
              <div>
                <dt className="font-narrow text-2xl md:text-3xl font-semibold">Pump</dt>
                <dd className="text-sm text-v2-muted">uma mão só, no banho</dd>
              </div>
            </dl>
            <PriceBlock product={big} className="mt-6" />
            {big && isSoldOut(big.node) ? (
            <Link to={`/produto/${H_1KG}`} className="mt-5 inline-flex items-center justify-center gap-2 min-h-12 px-6 rounded-full border border-v2-ink/20 font-semibold">
              Esgotado · Avise-me
            </Link>
            ) : (
            <button
              onClick={() => addToCart(big)}
              disabled={!big}
              className="mt-5 inline-flex items-center justify-center gap-2 min-h-12 px-6 rounded-full bg-v2-ink text-v2-bg font-semibold hover:bg-v2-ink/90 disabled:opacity-50"
            >
              <ShoppingBag className="w-4 h-4" /> Levar o tamanho família
            </button>
            )}
            <PurchaseBenefits />
          </div>
        </div>
      </div>
    </Reveal>
  );
};
